import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Mir Shahrukh Islam | Tech Entrepreneur & Forbes 30 Under 30",
  description = "Co-Founder & CEO of Bondstein Technologies. Forbes 30 Under 30 Asia. Building IoT solutions for enterprise digital transformation across South Asia and the Middle East.",
  image = "https://customer-assets.emergentagent.com/job_mir-shahrukh/artifacts/2k3cn254_Mir%20Shahrukh%20Islam_2.png",
  url = "",
  type = "website"
}) => {
  const siteUrl = "https://shahrukhislam.com";
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Canonical */}
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  );
};

export default SEO;
